import { __awaiter, __decorate } from "tslib";
import { customElement, observable } from '@microsoft/fast-element';
import { commonLoginRouteStyles } from '../../styles';
import { logger } from '../../utils';
import { BaseRoute } from '../base';
import { RequestAccountTemplate as template } from './request-account.template';
let RequestAccount = class RequestAccount extends BaseRoute {
    constructor() {
        super(...arguments);
        this.termsAgreed = false;
    }
    onSubmit() {
        const _super = Object.create(null, {
            onSubmit: { get: () => super.onSubmit }
        });
        return __awaiter(this, void 0, void 0, function* () {
            logger.debug('request account submission');
            yield _super.onSubmit.call(this);
        });
    }
};
__decorate([
    observable
], RequestAccount.prototype, "termsAgreed", void 0);
RequestAccount = __decorate([
    customElement({
        name: 'foundation-login-request-account',
        template,
        styles: commonLoginRouteStyles,
    })
], RequestAccount);
export { RequestAccount };
